import "./styles.css";
import { createEngine, clearBlack, drawVignette } from "./canvas/engine";
import { createUnicodeArt } from "./canvas/unicodeArt";
import { createEye } from "./canvas/eye";
import { createGlobe } from "./canvas/globe";
import { createScene } from "./canvas/scene";
import { createPointer } from "./input/pointer";

const canvas = document.querySelector<HTMLCanvasElement>("#portal");
if (!canvas) {
  throw new Error("#portal canvas not found");
}

const miniCanvas = document.querySelector<HTMLCanvasElement>(
  ".earth-link__globe",
);
if (!miniCanvas) {
  throw new Error(".earth-link__globe canvas not found");
}

const MINI = 72;
const miniCtx = miniCanvas.getContext("2d", {
  alpha: true,
  desynchronized: true,
});
if (!miniCtx) {
  throw new Error("2D canvas context unavailable");
}

const sizeMini = () => {
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  miniCanvas.width = Math.max(1, Math.floor(MINI * dpr));
  miniCanvas.height = Math.max(1, Math.floor(MINI * dpr));
  miniCanvas.style.width = `${MINI}px`;
  miniCanvas.style.height = `${MINI}px`;
  miniCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
};

sizeMini();
window.addEventListener("resize", sizeMini);

const engine = createEngine(canvas);
const pointer = createPointer(window);
const art = createUnicodeArt();
const eye = createEye();
const globe = createGlobe();
globe.opacity = 0.28;
const scene = createScene(art, eye);

engine.start((dt, now) => {
  const { ctx, width, height } = engine;
  clearBlack(ctx, width, height);
  scene.update(dt, now, pointer.state, width, height);
  scene.draw(ctx, width, height);
  drawVignette(ctx, width, height);

  const rect = miniCanvas.getBoundingClientRect();
  globe.update(
    dt,
    pointer.state.x,
    pointer.state.y,
    rect.left + rect.width / 2,
    rect.top + rect.height / 2,
  );
  miniCtx.clearRect(0, 0, MINI, MINI);
  globe.draw(miniCtx, MINI / 2, MINI / 2, MINI * 0.92);
});

// Clean up on HMR / unload.
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    engine.dispose();
    pointer.dispose();
    window.removeEventListener("resize", sizeMini);
  });
}
